const buildDriverAcceptance = (booking, { uid, profile, task }) => {
  if (!booking || !booking.requestedDrivers) return undefined;

  const nextBooking = Object.assign({}, booking, {
    driver: uid,
    driver_image: profile.profile_image ? profile.profile_image : '',
    car_image: profile.car_image ? profile.car_image : '',
    driver_name: profile.firstName + ' ' + profile.lastName,
    driver_contact: profile.mobile,
    driver_token: profile.pushToken ? profile.pushToken : '',
    vehicle_number: profile.vehicleNumber ? profile.vehicleNumber : '',
    vehicleModel: profile.vehicleModel ? profile.vehicleModel : '',
    vehicleMake: profile.vehicleMake ? profile.vehicleMake : '',
    driverRating: profile.rating ? profile.rating : '0',
    fleetadmin: profile.fleetadmin ? profile.fleetadmin : '',
    status: 'ACCEPTED',
    driverDeviceId: task.driverDeviceId ? task.driverDeviceId : null,
    requestedDrivers: null,
    driverEstimates: null,
  });

  if (!booking._serverPaymentProof) {
    const fleetCommissionFee = profile.fleetadmin
      ? ((parseFloat(booking.estimate) - parseFloat(booking.convenience_fees)) * parseFloat(booking.fleet_admin_comission) / 100).toFixed(2)
      : 0;
    const driverFee = parseFloat(parseFloat(booking.estimate) - (parseFloat(booking.convenience_fees) + parseFloat(fleetCommissionFee))).toFixed(2);

    nextBooking.fleetCommission = fleetCommissionFee ? fleetCommissionFee : '0';
    nextBooking.driver_share = driverFee ? driverFee : '0';
  }

  return nextBooking;
};

const isVerifiedDriverAcceptance = (result, uid) => {
  if (!result || result.committed !== true || !result.snapshot || typeof result.snapshot.val !== 'function') return false;

  const booking = result.snapshot.val();
  return Boolean(booking && booking.driver === uid && booking.requestedDrivers == null);
};

module.exports = { buildDriverAcceptance, isVerifiedDriverAcceptance };
